module.exports = __webpack_public_path__ + "img/imageNA.77dc4548.jpg";